export type TeamMemberDef = {
    imageIndex: number;
    nameKey: string;
    roleKey: string;
};

export const ABOUT_US_TEAM: TeamMemberDef[] = [
    {
        imageIndex: 0,
        nameKey: 'about-us.team.members.1.name',
        roleKey: 'about-us.team.members.1.role',
    },
    {
        imageIndex: 1,
        nameKey: 'about-us.team.members.2.name',
        roleKey: 'about-us.team.members.2.role',
    },
    {
        imageIndex: 2,
        nameKey: 'about-us.team.members.3.name',
        roleKey: 'about-us.team.members.3.role',
    },
];
